import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const header = document.querySelector('[data-site-header], .header');

  if (!header) return;

  const searchToggles = header.querySelectorAll('[data-search-toggle]');
  const searchPanel = header.querySelector('#header-search-panel');
  const searchClose = searchPanel?.querySelector('[data-search-close]');
  const searchInput = searchPanel?.querySelector('input[type="search"]');

  if (searchToggles.length && searchPanel) {
    let activeToggle = null;

    const closeSearch = (restoreFocus = false) => {
      header.classList.remove('is-search-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchPanel.inert = true;
      searchToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
      });

      if (restoreFocus) activeToggle?.focus();
    };

    const openSearch = (toggle) => {
      activeToggle = toggle;
      header.classList.add('is-search-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      searchPanel.inert = false;
      searchToggles.forEach((searchToggle) => {
        searchToggle.setAttribute('aria-expanded', 'true');
      });
      window.requestAnimationFrame(() => searchInput?.focus());
    };

    searchToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        if (header.classList.contains('is-search-open')) {
          closeSearch();
          return;
        }

        openSearch(toggle);
      });
    });

    searchClose?.addEventListener('click', () => closeSearch(true));

    document.addEventListener('pointerdown', (event) => {
      if (
        header.classList.contains('is-search-open') &&
        !searchPanel.contains(event.target) &&
        !event.target.closest('[data-search-toggle]')
      ) {
        closeSearch();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        header.classList.contains('is-search-open')
      ) {
        closeSearch(true);
      }
    });
  }

  const isHomeHeader =
    header?.classList.contains('header--home') ||
    document.body.classList.contains('home') ||
    document.body.classList.contains('page-template-template-home');

  if (!isHomeHeader) return;

  let isTicking = false;

  const updateHeaderState = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 16);
    isTicking = false;
  };

  const requestHeaderUpdate = () => {
    if (isTicking) return;

    isTicking = true;
    window.requestAnimationFrame(updateHeaderState);
  };

  updateHeaderState();
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
});
